<!--
 * @Author: 仙道
 * @Date: 2022-08-20 16:08:44
 * @LastEditTime: 2023-04-10 14:02:30
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/VideoModal/index.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <!-- <component :is="fusionView" :query="fusionQuery" ref="detailPage" v-if="visible" /> -->
    <div class="flex">
      <div class="w-300px pr-20px" v-if="leftList.length>0">
        <a-directory-tree
          :defaultSelectedKeys="defaultSelectedKeys"
          @select="selectUrl"
          default-expand-all
          v-if="constTreeList.length>0"
        >
          <!--  :treeData="urlTreeData" -->
          <a-tree-node :key="tree.key" :title="tree.title" v-for="(tree) in constTreeList">
            <a-tree-node :key="children.key" :title="children.title" is-leaf v-for="(children) in tree.children" />
          </a-tree-node>
        </a-directory-tree>
      </div>
      <!-- 如果是页面集成(url中包含 .htm)使用iframe嵌入，如果是视频流使用播放器播放 -->
      <template v-if="videoUrl">
        <iframe
          :src="videoUrl"
          allow="autoplay"
          allowfullscreen
          frameborder="0"
          style="width:100%;height:560px;"
          v-if="videoUrl.indexOf('.htm') > -1 "
        ></iframe>
        <player :videoUrl="videoUrl" v-else />
      </template>
    </div>
    <!-- </div> -->
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
      <!-- <a-button ghost type="primary" v-print="'#printContent'">打印</a-button> -->
    </template>
  </j-modal>
</template>

<script>
  import Player from '@/views/video/modules/player.vue'
  import { postAction } from '@/api/manage'

  export default {
    name: 'VideoModal',
    components: {
      Player
    },

    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        videoUrl: '',
        leftList: [],
        constTreeList: [],
        defaultSelectedKeys: []
      }
    },
    methods: {
      show (record) {

        this.videoUrl = this.leftList.length > 0 ? this.leftList[0].liveUrl : record.liveUrl

        this.visible = true
        // 预置位
        if (this.leftList.length == 0) return
        this.presetAction(this.leftList[0])
        this.constTreeList = this.leftList.map(item => {
          return {
            children: [],
            key: item.deviceId + '-' + item.presetId,
            title: item.videoName + '->' + item.businessName
          }
        })
        this.defaultSelectedKeys = [this.constTreeList[0].key]

      },

      close () {
        this.$emit('ok');
        this.visible = false;
      },
      handleOk () {
        // this.$refs.detailPage.submitForm();
      },
      submitCallback (id = '') {
        this.$emit('ok', id);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      presetAction (data) {
        const { channelId, deviceId, preset, liveUrl } = data;
        this.videoUrl = liveUrl;
        postAction('/video/videoDevice/operateVideo', {
          "channelId": channelId,
          "deviceId": deviceId,
          "operateType": "presets",
          "preset": preset
        }).then((res) => {


        })
      },
      selectUrl (selectedKeys, event) {
        const findKey = selectedKeys[0].split('-')
        const keyItem = this.leftList.find(item => item.deviceId == findKey[0])
        this.presetAction(keyItem)
      }
    }
  }
</script>